module.exports = __webpack_public_path__ + "j.no2.8120188c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/j.no2.jpg
// module id = 7CPn
// module chunks = 0